import { render, staticRenderFns } from "./Node.vue?vue&type=template&id=2ae6cee8&scoped=true&"
import script from "./Node.vue?vue&type=script&lang=js&"
export * from "./Node.vue?vue&type=script&lang=js&"
import style0 from "./Node.vue?vue&type=style&index=0&id=2ae6cee8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../demo/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae6cee8",
  null
  
)

export default component.exports